import { useLocation } from 'react-router-dom';
import { TTabname } from '..';

const useTabSelected = () => {

  const { pathname } = useLocation();

  const tabSelected = pathname.split('/').reverse()[0] as TTabname;

  const title = (
    tabSelected === 'permissions'
      ? `Permissions`
      : tabSelected === 'audit-logs'
        ? `Journaux d'audit`
        : tabSelected === 'payment-providers'
          ? `Moyens de paiement`
          : tabSelected === 'payment-packages'
            ? `Forfaits`
            : tabSelected === 'payment-method-requests'
              ? `Demandes de moyens de paiement`
              : `Outils`
  );

  return ({
    tabSelected,
    title
  });

};

export default useTabSelected;
